import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '存储在',
    type: 'BDRULE_DT',
}
